import { InsiderUserDTO } from "./insider-user.dto";

export class InsiderObjectDTO {
  user: {
    name?: string;
    email?: string;
    phone_number?: string;
    gdpr_optin?: boolean | null;
    custom?: {
      [key: string]: any;
    };
  };

  /**
   * Constructs a new InsiderObject.
   * @constructor
   * @param {Object} params - The parameters for creating an InsiderObject.
   * @param {InsiderUser} [params.user] - The user associated with the object.
   */
  constructor({ user, ...rest }: { user?: InsiderUserDTO }) {
    Object.assign(this, rest);

    const { name, email, phone_number, gdpr_optin, custom } = user ?? {};

    this.user = {
      ...(name && { name }),
      ...(email && { email }),
      ...(phone_number && { phone_number: phone_number }),
      ...(gdpr_optin !== null && { gdpr_optin: gdpr_optin }),
      ...(custom && Object.keys(custom).length !== 0 && { custom }),
    };
  }
}
